import { IMAGE, IMAGE_MOBILE } from '../elements/assets'

export const QUOTES_CAROUSEL_V2 = `
...on quotesCarouselV2_Entry {
  id
  typeHandle

  quotesCarouselContent {

    headingAdvanced { html }

    ... on quotesCarouselContent_Entry {
      quotesCarousel {
        ... on quotesCarouselSlide_Entry {
          id

          quote

          authorName
          position


          ${ IMAGE }
          ${ IMAGE_MOBILE }

        }
      }
    }
  }
}
`